import {AfterViewInit, Component, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {EtlExportUpdateComponent} from '../etl-export-update.component';
import {Field, InfoView, Query} from '../../../../components/filter/filter.type';
import {ClassicTreeSave} from '../../../../components/filter/filter-preset/filter-preset.component';
import {
    ConfiguratorDatastoreService,
    ConfiguratorDataViewService,
    ConfiguratorEtlService,
    ConfiguratorTableService,
    DataViewDto,
    EtlConf,
    EtlExportSearchDTO,
    FieldTable,
    FieldTableDto,
    ReplaceHeaderTransformConf,
    SaveQuery,
    SaveQueryExtractConf,
    Table
} from '@tj/tj-dmp-lib-api';
import {FilterBuilderService} from '../../../../services/filter-builder.service';
import {parseType} from '../../../../components/filter/filter.utils';
import {TableMetaComponent} from '../../../../components/table-data/table-meta/table-meta.component';
import {ConfirmationService, TreeNode} from 'primeng/api';
import {SelectSaveQueryComponent} from '../../../../components/select-save-query/select-save-query.component';
import {FilterPresetService} from '../../../../components/filter/filter-preset/filter-preset.service';
import {AccountService} from '../../../../auth/account.service';
import {isAdminOfTenant} from '../../../../auth/admin-levels';
import {FilterResult} from '../../../../components/filter/filter-result.interface';
import {BeautifulFilterComponent} from '../../../../components/filter/beautiful-filter/beautiful-filter.component';
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

/** Valeur de EtlConf.owner pour un export créé par un administrateur (et non par un affilié). */
const ADMIN_OWNER = 'admin';


@Component({
    selector: 'dmp-etl-export-update-search',
    templateUrl: './etl-export-update-search.component.html',
    styleUrls: ['./etl-export-update-search.component.scss'],
    providers: [ConfirmationService],
    standalone: false
})
export class EtlExportUpdateSearchComponent implements OnInit, AfterViewInit, OnDestroy {

    public id = '1';
    // FIXME JM : ???
    public tenant = 'T_AV';
    public view: InfoView;
    public dataView: DataViewDto;
    public tables: Array<Table>;
    public currentQuery: Query;
    saveQueryPartner: string;
    isAuthorizedAdmin: boolean;
    @ViewChild('table') table: TableMetaComponent;
    @ViewChild('filter') filter: BeautifulFilterComponent;
    @ViewChild('selectSaveQuery') selectSaveQuery: SelectSaveQueryComponent;

    public currentTreeFilter: TreeNode;
    private currentSaveQuery: SaveQuery;
    private currentTabParam: ClassicTreeSave;
    public presetSelected: ClassicTreeSave;
    /** Affilié dont les données sont prévisualisées. */
    public previewPartner: string;
    /** Affiliés parmi lesquels l'utilisateur peut choisir pour la prévisualisation. */
    public previewPartners: string[] = [];
    public exportPartners: string[] = [];
    public separateExport = false;
    /** Export groupé de plusieurs affiliés : l'aperçu montre leurs données dans une seule liste. */
    public groupedPartners: string[];
    /** Nom des affiliés du tenant, par code (libellé des onglets et pastilles). */
    public partnerNames: Record<string, string> = {};
    public readonly maxChips = 8;
    /** Colonne « Affiliés » ajoutée au fichier (export groupé de contacts sur plusieurs affiliés). */
    public exportAffiliatesColumn = false;

    /** Vue de contacts exportée en groupé sur plusieurs affiliés : l'aperçu montre les affiliés de chaque contact. */
    get contactAffiliatesPreview(): boolean {
        return !!this.groupedPartners && this.dataView?.table?.tableName === 'personal';
    }
    /** Affiliés que l'utilisateur courant est autorisé à consulter sur ce tenant. */
    public accessiblePartners: string[] = [];
    /**
     * false lorsque l'export est seulement *partagé* à l'utilisateur (présent dans
     * affectedPartners sans en être propriétaire) : les données ne lui sont pas affichables.
     */
    public canViewData = true;
    public selectedTables: string[] = [];
    public selectedColumns: string[] = [];
    public customHeader: ReplaceHeaderTransformConf[] = [];
    public saveQueryConf: SaveQueryExtractConf;

    /** etl$ appartient au parent, qui survit à cette étape : sans résiliation, le pipeline
     *  serait rejoué sur un composant détruit à chaque rechargement de l'ETL. */
    private readonly destroy$ = new Subject<void>();

    constructor(@Optional() public parent: EtlExportUpdateComponent,
                private readonly route: ActivatedRoute,
                private readonly router: Router,
                private readonly translate: TranslateService,
                private readonly configuratorDataViewService: ConfiguratorDataViewService,
                private readonly tableResourceService: ConfiguratorTableService,
                private readonly filterBuilderService: FilterBuilderService,
                private readonly configuratorEtlService: ConfiguratorEtlService,
                private readonly configuratorDatastoreService: ConfiguratorDatastoreService,
                private readonly service: FilterPresetService,
                private readonly accountService: AccountService,
                private readonly confirmationService: ConfirmationService) {
    }



    doInitFilterTreeTable() {
    }

    ngAfterViewInit(): void {

        const checkAndUpdateFilter = () => {
            // this.table.dataView n'est disponible qu'une fois l'init interne de dmp-table-meta terminée.
            // Sans cette condition, updateSaveQuery() peut déclencher table.updateQuery() avant que
            // dataView ne soit défini, ce qui fait planter callSearchQuery (this.dataView.code) et
            // laisse le tableau vide sans aucun retour visuel.
            if (this.filter && this.table && this.table.dataView && this.saveQueryConf && this.saveQueryConf.saveQuery) {
                if (this.saveQueryConf.saveQuery.objectQueryJson) {
                    setTimeout(() => {
                        this.filter.updateSaveQuery(this.saveQueryConf.saveQuery);
                    });
                }
                return true;
            }
            return false;
        };

        if (!checkAndUpdateFilter()) {
            const maxAttempts = 20;
            let attempts = 0;
            const intervalId = setInterval(() => {
                attempts++;
                // canViewData n'est connu qu'après la réponse serveur. Si l'export est seulement
                // partagé à l'utilisateur, ni le filtre ni le tableau ne sont rendus : on arrête
                // le sondage au lieu d'attendre l'expiration des tentatives.
                if (!this.canViewData) {
                    clearInterval(intervalId);
                    return;
                }
                if (checkAndUpdateFilter() || attempts >= maxAttempts) {
                    clearInterval(intervalId);
                    if (attempts >= maxAttempts) {
                        console.warn('Impossible de mettre à jour le filtre après plusieurs tentatives');
                    }
                }
            }, 200);
        }

        // setTimeout(() => {
        //     this.filter.updateSaveQuery(this.saveQueryConf.saveQuery);
        // }, 500);
    }

    ngOnInit(): void {
        this.accountService.fetch().pipe(
          tap(account => {
            // Aligné sur les autres écrans de l'ETL (étape Description, select-affected-partners) :
            // un admin de tenant est autorisé au même titre qu'un admin global. Ne tester que
            // account.admin faisait retomber les admins de tenant sur le premier affilié accessible
            // au lieu d'un affilié réellement affecté à l'export.
            this.isAuthorizedAdmin = isAdminOfTenant(account, this.parent.tenant);
          }),
          switchMap(() => this.parent.etl$),
          takeUntil(this.destroy$),
          filter(etl => !!etl && etl.extract?.typeObject === 'SaveQueryExtractConf'),
          switchMap(etl => {
            this.saveQueryConf = etl.extract as SaveQueryExtractConf;
            this.customHeader = etl.transforms?.filter(t => t.typeTransform === 'ReplaceHeaderTransformConf') ?? [];
            this.saveQueryPartner = etl.partner;

            // L'affilié doit être résolu AVANT la vue : la dataview et les données prévisualisées
            // doivent être lues pour le même affilié, sinon le tableau interroge un périmètre
            // différent de celui de la vue et ressort vide.
            return this.configuratorDatastoreService.getDatastoreAccessiblePartnersUsingGET(this.parent.tenant, true).pipe(
              switchMap(accessiblePartners => {
                this.accessiblePartners = accessiblePartners ?? [];
                this.canViewData = this.hasFullAccess(etl);
                this.exportPartners = etl.exportPartners ?? [];
                this.separateExport = etl.exportMode === 'SEPARATE';
                this.groupedPartners = !this.separateExport && this.exportPartners.length > 1 ? this.exportPartners : undefined;
                this.loadPartnerNames();
                this.exportAffiliatesColumn = !!etl.exportAffiliatesColumn;
                this.previewPartners = this.computePreviewPartners(etl);
                this.previewPartner = this.resolvePreviewPartner(etl);

                return this.configuratorDataViewService.getDataViewUsingGET(
                  this.parent.tenant, this.previewPartner, this.saveQueryConf.saveQuery.view, false
                ).pipe(
                  switchMap(dataView => {
                    this.dataView = dataView;
                    return this.tableResourceService.getTablesUsingGET(this.parent.tenant, dataView.tablesUsed);
                  })
                );
              }),
              tap(tables => {
                this.tables = tables;
                let havingCountTable: Table[] = [];
                if (this.dataView.havingCountTable) {
                    havingCountTable = this.tables.filter(t => this.dataView.havingCountTable.includes(t.code));
                }

                this.view = {
                  view: this.dataView.code,
                  partner: this.previewPartner,
                  datastore: this.parent.tenant,
                  havingCountTable
                };

                this.currentQuery = {
                  filter: this.saveQueryConf.saveQuery.query,
                  datastore: this.parent.tenant,
                  partner: this.previewPartner,
                  dataview: this.dataView.code,
                  dataviewId: this.dataView.id
                } as Query;

                this.currentTreeFilter = JSON.parse(this.saveQueryConf.saveQuery.objectQueryJson);
              })
            );
          })
        ).subscribe();
      }

    /**
     * Reprend la règle d'accès de la liste des exports (etl.component.ts) : un admin (global ou
     * du tenant) et le propriétaire de l'export ont un accès complet. Un affilié à qui l'export
     * est seulement *partagé* via affectedPartners peut le voir dans la liste mais ne doit pas
     * accéder aux données.
     */
    private hasFullAccess(etl: EtlConf): boolean {
        const isOwner = [etl.owner, etl.partner]
            .some(p => this.isRealPartner(p) && this.accessiblePartners.includes(p));
        return this.isAuthorizedAdmin || isOwner;
    }

    /**
     * EtlConf.owner vaut la chaîne conventionnelle 'admin' pour un export créé par un
     * administrateur : ce n'est pas un code affilié et il ne doit jamais servir de périmètre.
     */
    private isRealPartner(partner: string): boolean {
        return !!partner && partner !== ADMIN_OWNER;
    }

    /**
     * Affiliés proposés pour la prévisualisation.
     *
     * L'endpoint de données exige un affilié (en-tête X-PARTNER-ID) : il n'est pas possible
     * d'interroger plusieurs affiliés à la fois. La prévisualisation se fait donc affilié par
     * affilié, parmi ceux concernés par l'export (son propriétaire et ceux à qui il est partagé).
     */
    private computePreviewPartners(etl: EtlConf): string[] {
        if (etl.exportPartners?.length) {
            return this.isAuthorizedAdmin
                ? etl.exportPartners
                : etl.exportPartners.filter(p => this.accessiblePartners.includes(p));
        }
        const concerned = Array.from(new Set(
            [etl.partner, etl.owner, ...(etl.affectedPartners ?? [])].filter(p => this.isRealPartner(p))
        ));

        // Un admin peut prévisualiser tout affilié concerné par l'export, même hors de ses
        // affiliés « accessibles ». Un propriétaire se limite à ceux qu'il est autorisé à consulter.
        const partners = this.isAuthorizedAdmin
            ? concerned
            : this.accessiblePartners.filter(p => concerned.includes(p));

        // Dernier recours : l'endpoint de données exige un affilié, un écran sans affilié
        // provoquerait une exception au lieu d'un tableau vide.
        return partners.length > 0 ? partners : this.accessiblePartners;
    }

    /**
     * Affilié retenu par défaut : celui de l'export, sinon celui déjà enregistré dans la
     * recherche sauvegardée, sinon le premier affilié proposé.
     */
    private resolvePreviewPartner(etl: EtlConf): string {
        const preferred = [etl.partner, this.saveQueryConf.saveQuery.partner].filter(p => !!p);
        return preferred.find(p => this.previewPartners.includes(p)) ?? this.previewPartners[0];
    }

    private loadPartnerNames(): void {
        if (this.exportPartners.length < 2 || Object.keys(this.partnerNames).length > 0) {
            return;
        }
        this.configuratorDatastoreService.getDatastoreUsingGET(this.parent.tenant, true).subscribe(datastore => {
            this.partnerNames = (datastore?.partners ?? []).reduce((names, p) => ({...names, [p.code]: p.name}), {});
        });
    }

    /** Change l'affilié prévisualisé sans réinitialiser le tableau : filtres et colonnes choisis sont conservés. */
    switchPreviewPartner(partner: string): void {
        if (!this.table?.dataView || !partner || partner === this.previewPartner) {
            return;
        }
        this.previewPartner = partner;
        this.table.partner = partner;
        this.table.paginator.start = 0;
        this.table.updateQuery();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get fields() {
        if (!this.tables) {
            return [];
        }

        return this.tables
            .filter(t => t.code !== 'personal_affi_auth')
            .map((table) => ({
                label: table.label || table.code,
                value: table.code,
                items: table.fields
                    .filter(f => f.categoryField !== FieldTable.CategoryFieldEnum.TECHNICAL)
                    .map((field) => ({
                        name: field.code,
                        label: field.label ?? field.code,
                        variableType: parseType(field.categoryField, field.type),
                        valueType: field.categoryField,
                        schema: table.code,
                    } as Field))
            }));
    }

    // importSaveQuery(op: OverlayPanel) {
    //     this.filter.updateSaveQuery(this.selectSaveQuery.getCurrentSaveQuery());
    //     op.hide();
    // }

    importSaveQuery() {
        // Même garde que dans ngAfterViewInit() : si dmp-table-meta n'a pas fini son init interne
        // (dataView pas encore défini), table.updateQuery() plante silencieusement (this.dataView.code).
        if (!this.table?.dataView) {
            return;
        }
        const preset = this.selectSaveQuery?.getCurrentSaveQuery();
        if (!preset) {
            return;
        }
        // Le preset remplace les filtres : confirmation seulement s'il y a déjà des filtres
        if (!this.currentTreeFilter?.children?.length) {
            this.filter.updateSaveQuery(preset);
            return;
        }
        this.confirmationService.confirm({
            header: this.translate.instant('etl.export.search.importPresetLabel'),
            message: this.translate.instant('etl.export.search.presetReplaceConfirm'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translate.instant('etl.export.search.loadPreset'),
            rejectLabel: this.translate.instant('common.cancel'),
            accept: () => this.filter.updateSaveQuery(preset)
        });
    }

    doSaveQueryChanged(filterResult: FilterResult) {
        if (filterResult.filters) {
            this.currentTreeFilter = filterResult.filters;
        }
        if (filterResult.filters) {
            this.currentSaveQuery = filterResult.saveQuery;
        }
        if (filterResult.tabParam) {
            this.currentTabParam = filterResult.tabParam;
        }
        if (this.currentTabParam?.cols && this.currentTabParam.cols.length > 0) {
            this.selectedTables = this.currentTabParam.cols.map(s => s.split('.')[0]);
            this.selectedColumns = this.currentTabParam.cols.map(s => s.split('.')[1]);
        }
        this.table.updateQuery(
            this.filterBuilderService.buildTreeQuery(this.currentTreeFilter),
            // this.filterBuilderService.buildOrderings(this.currentTabParam?.orderings),
            undefined,
            this.currentTabParam?.cols,
            this.currentTabParam?.having
        );
        /*this.currentTreeFilter = ($event == null || $event.value == null) ? null : $event.value;
        this.presetSelected = $event;
        if ($event?.cols && $event?.cols.length > 0) {
            this.selectedColumns = $event.cols.map(s => s.split('.')[1]);
        }
        if (this.table) {
            console.log('Table est initialisé, mise à jour du query');
            this.table.updateQuery(
                this.filterBuilderService.buildTreeQuery(this.currentTreeFilter),
                this.filterBuilderService.buildOrderings($event?.orderings),
                $event?.cols
            );
        } else {
            console.error('Table n\'est pas initialisé lors de doSaveQueryChanged');
        }*/
    }

    onSelectedColumnsChange($event: FieldTableDto[]) {

    }

    saveStep() {
        const cols = this.table.colsSelected.map(c => c.key);
        let treeNode = null;
        if (this.currentTreeFilter) {
            treeNode = this.service.removeFilterWithNoType(this.currentTreeFilter);
        }
        const query: SaveQuery = {
            datastore: this.parent.tenant,
            displayables: cols,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            orderings: this.currentQuery.filter.orderings.map((el) => ({ order: el.order, code: (el.operand as any).propertyName })),
            partner: this.view.partner,
            query: this.currentQuery.filter,
            objectQueryJson: JSON.stringify(this.service.removeCircular(treeNode)),
            view: this.dataView.id
        };
        const etl = {
            id: this.parent.id,
            tenant: this.parent.tenant,
            saveQuery: query,
            replaceHeaderTransform: this.table.getSelectedColumnsWithExportLabels(),
            exportAffiliatesColumn: this.contactAffiliatesPreview && this.exportAffiliatesColumn
        } as EtlExportSearchDTO;
        // Comme l'étape Description : rediffuser l'ETL enregistré, sinon un retour sur cette étape
        // réafficherait les filtres d'avant l'enregistrement.
        this.configuratorEtlService.updateExportSearch(etl, this.parent.tenant).pipe(
            switchMap(() => this.parent.reloadEtl())
        ).subscribe(() => {
            this.parent.goToNextStep();
        });
    }
}
